import React from 'react'
import Pg2 from '../../../myapp/services/add-money/Pg/Pg2'

function PG2Page() {
  return (
    <Pg2/>
  )
}

export default PG2Page